import { inject, Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { environment } from '@env'
import { PlayerComparison, PlayerComparisonRequest } from '@core/models/player.models'
import { MetricMap, MetricRequest } from '@core/models/metric.models'
import { Observable } from 'rxjs'
import { Aggregation } from '@features/aggregations/models/aggregations.models'

@Injectable({ providedIn: 'root' })
export class MetricsFinderApi {
  private readonly _http: HttpClient = inject(HttpClient)

  fetchPlayerMetrics(payload: MetricRequest): Observable<MetricMap> {
    const { playerId, playerPosition, aggregationDataSource, seasonId, competitionId, teamId } = payload
    const params = playerPosition
      ? new HttpParams().set('aggregationDataSource', aggregationDataSource).set('playerPosition', playerPosition)
      : new HttpParams().set('aggregationDataSource', aggregationDataSource)

    return this._http.get<MetricMap>(
      environment.api.playerMetricResultsUrlFn(seasonId, competitionId, teamId, playerId),
      {
        params
      }
    )
  }

  fetchPlayerComparisonMetrics(playerComparison: PlayerComparisonRequest): Observable<PlayerComparison> {
    return this._http.post<PlayerComparison>(environment.api.comparePlayersUrl, playerComparison)
  }

  fetchMatchPlayerComparisonMetrics(
    matchId: string,
    comparison: PlayerComparisonRequest,
    playerPosition: string
  ): Observable<PlayerComparison> {
    return this._http.post<PlayerComparison>(environment.api.matchComparePlayersUrlFn(matchId), {
      ...comparison,
      PlayerPosition: playerPosition
    })
  }

  fetchMatchMetrics(
    seasonId: string,
    competitionId: string,
    matchId: string,
    aggregationDataSource: Aggregation
  ): Observable<MetricMap> {
    return this._http.get<MetricMap>(
      environment.api.matchTeamMetricsWithContextUrlFn(seasonId, competitionId, matchId),
      {
        params: { aggregationDataSource }
      }
    )
  }
}
